import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 text-background-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-database-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                Hipobuy Sheet
              </span>
            </div>
            <p className="text-xs text-foreground-500 leading-relaxed mb-4">
              The ultimate spreadsheet resource center for product discovery, shopping research, comparison guides, and buyer education.
            </p>
            <Link
              to="/hipobuy-spreadsheet-guide/"
              className="inline-flex items-center gap-1.5 text-xs text-primary-400 hover:text-primary-300 transition-colors duration-200"
            >
              Read Our Complete Guide
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">SEO Guides</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/hipobuy-spreadsheet-guide/" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Hipobuy Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-spreadsheet-guide/" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Kakobuy Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/cssbuy-spreadsheet-guide/" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  CSSBuy Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/superbuy-spreadsheet-guide/" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Superbuy Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/oopbuy-spreadsheet-guide/" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Oopbuy Spreadsheet Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Popular Categories</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Hoodies &amp; Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Jackets
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Accessories
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#categories" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Browse Categories
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Main Platform
                </a>
              </li>
              <li>
                <a href="/" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
                  Home
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 md:mt-12 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} Hipobuy Spreadsheet Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-200 transition-colors duration-200">
              Visit Main Site
              <i className="ri-external-link-line ml-1 text-xs"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}